(function () {
  if (window.OrionPersonalizationStore) return;
  var cache = new Map();
  var pending = new Map();
  var endpoint = '/apps/pricing-preview/personalization-config';

  function compactProperties(input) {
    var props = Object.assign({}, input || {});
    if (!props._custom_group_id && props._personalization_group) props._custom_group_id = props._personalization_group;
    delete props._personalization_group;
    delete props._pz_variants_stock_json;
    delete props._fee_variant_title;
    if (props._personalization_config_id) {
      ['_personalization_json', '_bat_payload', '_selected_print_options', '_print_options_label'].forEach(function (key) { delete props[key]; });
      if (props._personalization_fee !== 'true') delete props._selected_zone;
      if (props.personnalisation) props.personnalisation = String(props.personnalisation).slice(0, 500);
    }
    Object.keys(props).forEach(function (key) { if (props[key] === undefined || props[key] === null || props[key] === '') delete props[key]; });
    return props;
  }

  async function prepare(config, files) {
    var sources = files.slice();
    var dataIndex = new Map();
    for (var i = 0; i < sources.length; i++) if (sources[i].dataUrl) dataIndex.set(sources[i].dataUrl, i);
    async function sourceReference(value) {
      if (!dataIndex.has(value)) {
        var blob = await (await fetch(value)).blob();
        var ext = { 'image/png': 'png', 'image/jpeg': 'jpg', 'image/webp': 'webp', 'image/gif': 'gif', 'image/avif': 'avif' }[blob.type];
        if (!ext) throw new Error('Format de ressource non pris en charge. Utilisez PNG, JPG, WebP ou GIF.');
        dataIndex.set(value, sources.length);
        sources.push({ blob: blob, name: 'apercu-' + sources.length + '.' + ext, dataUrl: value });
      }
      return 'orion-source:' + dataIndex.get(value);
    }
    async function visit(value) {
      if (typeof value === 'string' && value.startsWith('data:')) {
        return sourceReference(value);
      }
      if (Array.isArray(value)) { var list = []; for (var child of value) list.push(await visit(child)); return list; }
      if (value && typeof value === 'object') {
        var result = {};
        var original = typeof value.personalizerSourceDataUrl === 'string' && value.personalizerSourceDataUrl.startsWith('data:')
          ? await sourceReference(value.personalizerSourceDataUrl)
          : null;
        for (var key of Object.keys(value)) {
          if (['__proto__', 'prototype', 'constructor'].includes(key)) throw new Error('Configuration invalide.');
          result[key] = original && (key === 'src' || key === 'personalizerSourceDataUrl') &&
            typeof value[key] === 'string' && value[key].startsWith('data:') ? original : await visit(value[key]);
        }
        return result;
      }
      return value;
    }
    var normalized = await visit(config);
    var json = JSON.stringify(normalized);
    if (new Blob([json]).size > 2 * 1024 * 1024 || new Blob([JSON.stringify(normalized.batPayload)]).size > 256 * 1024) {
      throw new Error('Votre personnalisation contient trop de détails. Simplifiez-la puis réessayez.');
    }
    if (sources.length > 120) throw new Error('Votre personnalisation contient trop de ressources images.');
    return { json: json, files: sources };
  }

  async function request(body) {
    var response = await fetch(endpoint, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    var payload = await response.json().catch(function () { return {}; });
    if (!response.ok || !payload.ok) throw new Error(payload.error || 'La personnalisation sauvegardée est indisponible.');
    return payload;
  }
  function load(id, group, resources) {
    var key = id + ':' + group + ':' + !!resources;
    if (cache.has(key)) return Promise.resolve(cache.get(key));
    if (pending.has(key)) return pending.get(key);
    var promise = request({ id: id, customGroupId: group, includeResources: !!resources }).then(function (payload) {
      cache.set(key, payload.config); return payload.config;
    }).finally(function () { pending.delete(key); });
    pending.set(key, promise); return promise;
  }
  function peek(id, group) { return cache.get(id + ':' + group + ':false'); }
  async function hydrateCart(cart) {
    await Promise.all((cart.items || []).filter(function (line) { return line.properties && line.properties._personalization_config_id; }).map(function (line) {
      var props = line.properties;
      return load(props._personalization_config_id, props._custom_group_id || props._personalization_group, false).catch(function () { return null; });
    }));
    return cart;
  }
  window.OrionPersonalizationStore = {
    compactProperties: compactProperties, prepare: prepare, load: load, peek: peek, hydrateCart: hydrateCart,
    clone: function (id, group, nextGroup) { return request({ operation: 'clone', id: id, customGroupId: group, nextGroupId: nextGroup }); }
  };
})();
